import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsCustomWebsitesTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.custom-websites')} />
      <IntegrationsTable category={IntegrationCategory.CUSTOM_WEBSITES} />
    </section>
  );
};

export default IntegrationsCustomWebsitesTab;
